import React from 'react';
import _ from 'underscore';

import {MY_PROJECTS, SHARED_WITH_ME, STARRED} from 'nav/sidepanel/listing/ProjectListingUtil';
import {Organization, Team} from 'orgs/OrganizationConstants';
import DropdownFilterForm, {getFilterText} from 'search/filters/base/DropdownFilterForm';
import {FilterKey, GenericFilter} from 'search/SearchConstants';
import {OptionData} from 'ui-library/menus/MenuConstants';
import pickDefined from 'util/pickDefined';

import {BASE_FILTER_FORM_PROP_NAMES, BaseFilterFormProps, FilterStyle} from './base/FilterFormConstants';

interface SharedWithFilterFormProps extends BaseFilterFormProps {
  filter: GenericFilter<FilterKey.SHARED_WITH>;
  filterStyle: FilterStyle;
  onChangeFilter: (filter: GenericFilter<FilterKey.SHARED_WITH>) => void;
  onRemove?: () => void;
  teams: Array<Team>;
  organizations: Array<Organization>;
  showSharedWithMe: boolean;
  showMyProjects: boolean;
  showStarred: boolean;
}

export interface SharedWithFilterFormExtraProps {
  teams: Array<Team>;
  organizations: Array<Organization>;
  showSharedWithMe: boolean;
  showMyProjects: boolean;
  showStarred: boolean;
}

/**
 * A filter to filter projects by a team or organization collaborator.
 */
export default function SharedWithFilterForm(
  props: SharedWithFilterFormProps & SharedWithFilterFormExtraProps
): JSX.Element {
  const skeletonProps = pickDefined(props, ...BASE_FILTER_FORM_PROP_NAMES);
  const teams: Array<OptionData> = props.teams.map((team) => ({
    name: team.name,
    value: team.id,
    icon: 'team',
  }));
  const orgs: Array<OptionData> = props.organizations.map((org) => ({
    name: org.name,
    value: org.id,
    icon: 'organization',
  }));
  const optionDatas: Array<OptionData> = _.compact([
    {name: 'All projects', value: null},
    props.showMyProjects && {name: 'My projects', value: MY_PROJECTS, icon: 'user'},
    props.showSharedWithMe && {name: 'Shared with me', value: SHARED_WITH_ME, icon: 'user'},
    props.showStarred && {name: 'Starred projects', value: STARRED, icon: 'star'},
    ..._.sortBy(orgs, (item) => item.name),
    ..._.sortBy(teams, (item) => item.name),
  ]);

  return (
    <DropdownFilterForm
      {...skeletonProps}
      dropdownToggleText={getFilterText(optionDatas, props.filter) || 'All projects'}
      filterStyle={props.filterStyle}
      isMulti={false}
      onChangeValue={(value: Array<string>) => {
        // @ts-expect-error BNCH(56464): Fix this. SharedWith is a SingleValueFilter in `SearchConstants.ts`,
        // but here we are trying to assign an array of strings.
        props.onChangeFilter({...props.filter, value});
      }}
      onRemove={props.onRemove}
      optionDatas={optionDatas}
      value={props.filter.value}
    />
  );
}
